import apiClient from '../config/axios';
import { ENDPOINTS } from '../constants/endpoints';

export const familleTypeArticleService = {
  // Get famille type articles with pagination and filters
  getFamilleTypeArticles: async (pageSize = 10, page = 1, filters = {}) => {
    try {
      // Build the URL with path parameters for pagination
      const url = `${ENDPOINTS.FAMILLE_TYPE_ARTICLE}/${pageSize}/${page}`;
      
      // Build query parameters for filters only
      const params = {};

      // Add filters if they exist
      if (filters.searchTerms) {
        params.SearchTerms = filters.searchTerms;
      }

      const response = await apiClient.get(url, {
        params: params
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching famille type articles:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des familles de types d\'articles',
        error: error.response?.data,
      };
    }
  },

  // Get famille type article by ID
  getFamilleTypeArticleById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.FAMILLE_TYPE_ARTICLES}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get famille type article by ID error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement de la famille de type d\'article',
        error: error.response?.data,
      };
    }
  },

  // Create new famille type article
  createFamilleTypeArticle: async (familleTypeArticleData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.FAMILLE_TYPE_ARTICLE, familleTypeArticleData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Create famille type article error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création de la famille de type d\'article',
        error: error.response?.data,
      };
    }
  },

  // Update famille type article
  updateFamilleTypeArticle: async (id, familleTypeArticleData) => {
    try {
      const response = await apiClient.put(ENDPOINTS.FAMILLE_TYPE_ARTICLE, {
        ...familleTypeArticleData,
        id: id,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Update famille type article error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour de la famille de type d\'article',
        error: error.response?.data,
      };
    }
  },

  // Delete famille type article
  deleteFamilleTypeArticle: async (id) => {
    try {
      const response = await apiClient.delete(`${ENDPOINTS.FAMILLE_TYPE_ARTICLE}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Delete famille type article error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression de la famille de type d\'article',
        error: error.response?.data,
      };
    }
  },
};

export default familleTypeArticleService;